import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as sortableListActions from "../../../actions/common/sortableListActions";
import BaseList from "../list/BaseList";

class TextHighlighter extends BaseList {
    constructor(props) {
        super(props);
    }

    pregQuote(str) {
        return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    }

    highlight(text) {
        if(!this.props.sortableList) {
            return text;
        }
        let searchedQuery = this.props.sortableList.search;

        text = text.toString();
        return text.replace( new RegExp( "(" + this.pregQuote( searchedQuery ) + ")" , 'gi' ), "<mark>$1</mark>");
    }

    render() {
        return (
            <div>
                { ReactHtmlParser(this.highlight(this.props.text)) }
            </div>
        );
    }

}

function mapStateToProps(state, ownProps) {
    return {
        sortableList: state.sortableList[ownProps.listId],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                sortableListActions
            ), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextHighlighter);


// WEBPACK FOOTER //
// ./web/src/components/common/searchbar/TextHighlighter.jsx